/** Statuts pièces — devis aujourd’hui, facture / avoir / récurrent demain. */

export type DocStatusKind = "draft" | "sent" | "viewed" | "signed" | "converted" | "refused" | "paid" | "partial" | "overdue" | "due" | "credited" | "collecting" | "rejected";

export type StatusSource = {
  doc_type?: string;
  status?: string;
  signed?: boolean;
  signed_at?: string | null;
  signature?: { signed_at?: string } | null;
  refused_at?: string | null;
  refusal?: { refused_at?: string } | null;
  viewed_at?: string | null;
  due_date?: string | null;
  converted_invoice_id?: number | null;
  credit_note_id?: number | null;
  credited?: boolean;
  paid?: boolean;
  paid_cents?: number;
  remaining_cents?: number;
  overdue?: boolean;
  gc_charge?: { status?: string; open?: boolean; failed?: boolean; paid?: boolean } | null;
};

export function docStatusLabel(kind: DocStatusKind): string {
  if (kind === "draft") return "Brouillon";
  if (kind === "sent") return "Envoyé";
  if (kind === "viewed") return "Vu";
  if (kind === "signed") return "Signé";
  if (kind === "converted") return "Converti";
  if (kind === "refused") return "Refusé";
  if (kind === "paid") return "Payé";
  if (kind === "partial") return "Partiel";
  if (kind === "overdue") return "Retard";
  if (kind === "credited") return "Annulée";
  if (kind === "collecting") return "En paiement";
  if (kind === "rejected") return "Rejeté";
  return "À payer";
}

const GC_OPEN = ["pending", "pending_submission", "pending_customer_approval", "submitted", "created"];
const GC_REJECTED = ["failed", "cancelled", "customer_approval_denied", "charged_back", "late_failure"];

function invoiceDuePast(row: StatusSource): boolean {
  if (row.status !== "validated" || !row.due_date) return false;
  return row.due_date < new Date().toISOString().slice(0, 10);
}

export function docStatusKind(row: StatusSource): DocStatusKind {
  const type = row.doc_type || "quote";
  if (type === "invoice") {
    if (row.credited) return "credited";
    if (row.paid) return "paid";
    if (row.gc_charge?.failed === true || GC_REJECTED.includes(row.gc_charge?.status || "")) {
      return "rejected";
    }
    if (row.gc_charge?.open === true || GC_OPEN.includes(row.gc_charge?.status || "")) {
      return "collecting";
    }
    if ((Number(row.paid_cents) || 0) > 0) return "partial";
    if (row.overdue || invoiceDuePast(row)) return "overdue";
    if (row.viewed_at) return "viewed";
    if (row.status === "validated") return "sent";
    return "draft";
  }
  if (type === "credit_note") {
    if (row.viewed_at) return "viewed";
    if (row.status === "validated") return "sent";
    return "draft";
  }
  if (row.converted_invoice_id) return "converted";
  if (row.refused_at || row.refusal?.refused_at) return "refused";
  if (row.signed || row.signed_at || row.signature?.signed_at) return "signed";
  if (row.status === "draft") return "draft";
  return row.viewed_at ? "viewed" : "sent";
}
